/*
 * Authors: mariushirjanu
 * Created: 02/08/2022
 */
import { util } from '../util';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { IRecord } from '../../../type_definitions/datatypes';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';

export interface IImage extends IRecord {
  url:string;
}

const CONTAINER_NAME:string = 'REORDER_IMAGES';

@Component({
  selector: 'reorder-images',
  template: `
      <div dragula="${CONTAINER_NAME}" [(dragulaModel)]="model"  class="form-horizontal sortable-list clearfix">
        <div *ngFor="let image of images; trackById" class="image">
          <i class="fa fa-ellipsis-v"></i>&nbsp; <img draggable="false" [src]="image.url" alt=""/>
        </div>
      </div>
  `,
  styleUrls: ['./reorder-images.scss']
})
export class ReorderImagesComponent implements OnInit, OnDestroy {
  @Input() public images:IImage[];
  @Output() public onChange: EventEmitter<IImage[]> = new EventEmitter<IImage[]>();

  public model:IImage[];
  private eventHandler:Subscription;

  constructor(
    private dragulaService:DragulaService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.start();
  }

  private start = ():void => {
    this.model = util.deepClone(this.images);
    this.listen();
  };

  private listen(){
    this.eventHandler = new Subscription();
    this.eventHandler.add(this.dragulaService.drop(CONTAINER_NAME)
      .subscribe(() => {
        this.onChange.emit(this.model);
      })
    );
  }

  public ngOnDestroy():void {
    this.eventHandler.unsubscribe();
  }
}